import { useModelService } from 'services/model/model.service';
import { useTranslatedAttribute } from '../../../i18n/translateAttributeHook';
import { AttributeDisplayDescriptor } from 'pages/entities/entities';
import { findIconForCategory } from 'pages/insights-pro/common/icons/CategoryIcons';
import { useNavigate } from 'react-router-dom';

export function AttributeBox(attributeDescriptor: AttributeDisplayDescriptor) {
  const modelService = useModelService();

  const navigate = useNavigate();

  const attribute = modelService.getAttribute(attributeDescriptor.attributeCode);
  const translatedAttribute = useTranslatedAttribute(
    attributeDescriptor.attributeCode,
    attributeDescriptor.attributeValue ?? ''
  );

  const label = attributeDescriptor.label ?? attribute.name;

  const onClick = () => {
    if (attributeDescriptor.link) {
      navigate(attributeDescriptor.link);
    }
  };

  return (
    <div className="text-sm col-span-1">
      <div className="font-semibold">{label}</div>
      <div
        onClick={onClick}
        className={`flex gap-1 items-center${attributeDescriptor.link ? ' cursor-pointer text-denim-500' : ''}`}
      >
        {attributeDescriptor.attributeCode === 'prdCategory' &&
          attributeDescriptor.attributeValue &&
          findIconForCategory(attributeDescriptor.attributeValue, 20)}
        {attributeDescriptor.useRaw ? attributeDescriptor.attributeValue : translatedAttribute}
      </div>
    </div>
  );
}
